import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Spinner,
  Modal,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";

import LoadingOverlay from "./LoadingOverlay";
export default class Tv_tokens extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      isSubmitting: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.tv_tokens_Id,
          sortable: true,
          cell: (row) => <span>{row.tv_tokens_Id}</span>,
        },
        {
          name: "Token",
          selector: (row, i) => row.token,
          sortable: true,
          cell: (row) => <span>{row.token}</span>,
        },
        {
          name: "User Id",
          selector: (row, i) => row.userId,
          sortable: true,
          cell: (row) => <span>{row.userId}</span>,
        },
        {
          name: "Role Id",
          selector: (row, i) => row.roleId,
          sortable: true,
          cell: (row) => <span>{row.roleId}</span>,
        },
        {
          name: "Description",
          selector: (row, i) => row.description,
          sortable: true,
          cell: (row) => <span>{row.description}</span>,
        },
        {
          name: "Is Active ",
          selector: (row, i) => row.isActive,
          sortable: true,
          cell: (row) => <span>{row.isActive}</span>,
        },
        {
          name: "Expires At",
          selector: (row, i) => row.expiresAt,
          sortable: true,
          cell: (row) => <span>{row.expiresAt}</span>,
        },
        {
          name: "Page Route",
          selector: (row, i) => row.pageRoute,
          sortable: true,
          cell: (row) => <span>{row.pageRoute}</span>,
        },
        {
          name: "Used At",
          selector: (row, i) => row.usedAt,
          sortable: true,
          cell: (row) => <span>{row.usedAt}</span>,
        },
        {
          name: "Token Type",
          selector: (row, i) => row.tokenType,
          sortable: true,
          cell: (row) => <span>{row.tokenType}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Tv_tokenseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      isEditing: false,
      tv_tokens_Id: "",
      token: "",
      userId: "",
      roleId: "",
      description: "",
      isActive: "",
      expiresAt: "",
      pageRoute: "",
      showOtpModal: false,
      generatedOtp: "",
      otpUserId: "",
      otpRoleId: "",
      otpDescription: "",
      otpPageRoute: "",
      isGenerating: false,
      usedAt: "",
      tokenType: "",
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName,
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName,
        );
        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName,
      );
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "token",
        inputType: "Text",
        displayName: "Token",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "userId",
        inputType: "Number",
        displayName: "User Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "roleId",
        inputType: "Number",
        displayName: "Role Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "description",
        inputType: "Text",
        displayName: "Description",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "isActive",
        inputType: "Number",
        displayName: "Is Active ",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "expiresAt",
        inputType: "Date",
        displayName: "Expires At",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "pageRoute",
        inputType: "Text",
        displayName: "Page Route",
        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      token: "",
      userId: "",
      roleId: "",
      description: "",
      isActive: "",
      expiresAt: "",
      pageRoute: "opsdashboard",
      usedAt: "",
      tokenType: "",
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      token: "",
      userId: "",
      roleId: "",
      description: "",
      isActive: "",
      expiresAt: "",
      pageRoute: "opsdashboard",
      usedAt: "",
      tokenType: "",
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Tv_tokenseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      tv_tokens_Id: row.tv_tokens_Id,
      token: row.token,
      userId: row.userId,
      roleId: row.roleId,
      description: row.description,
      isActive: row.isActive,
      expiresAt: row.expiresAt,
      pageRoute: row.pageRoute ,
      usedAt: row.usedAt,
      tokenType: row.tokenType,
      errors: {},
      touched: {},
    });
  };

  Tv_tokensfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Tv_tokens/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };

  Tv_tokenssubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      this.setState({ isSubmitting: false });
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("token", this.state.token);
    formData.append("userId", this.state.userId);
    formData.append("roleId", this.state.roleId);
    formData.append("description", this.state.description);
    formData.append("isActive", this.state.isActive);
    formData.append("expiresAt", this.state.expiresAt);
    formData.append("pageRoute", this.state.pageRoute);
    formData.append("usedAt", this.state.usedAt);
    formData.append("tokenType", this.state.tokenType);
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Tv_tokens/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tv_tokensfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            token: "",
            userId: "",
            roleId: "",
            description: "",
            isActive: "",
            expiresAt: "",
            pageRoute: "",
            usedAt: "",
            tokenType: "",
          });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });})
      .finally(() => this.setState({ isSubmitting: false }));
  };

  Tv_tokensupdateHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tv_tokens_Id", this.state.tv_tokens_Id);
    formData.append("token", this.state.token);
    formData.append("userId", this.state.userId);
    formData.append("roleId", this.state.roleId);
    formData.append("description", this.state.description);
    formData.append("isActive", this.state.isActive);
    formData.append("expiresAt", this.state.expiresAt);
    formData.append("pageRoute", this.state.pageRoute);
    formData.append("usedAt", this.state.usedAt);
    formData.append("tokenType", this.state.tokenType);
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Tv_tokens/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tv_tokensfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });})
      .finally(() => this.setState({ isSubmitting: false }));
  };

  componentDidMount() {
    this.Tv_tokensfetchHandler();
  }

  handletokenChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ token: fieldValue });
  };
  handleuserIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ userId: fieldValue });
  };
  handleroleIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ roleId: fieldValue });
  };
  handledescriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ description: fieldValue });
  };
  handleisActiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ isActive: fieldValue });
  };
  handleexpiresAtChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ expiresAt: fieldValue });
  };
  handlepageRouteChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pageRoute: fieldValue });
  };
  handleusedAtChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ usedAt: fieldValue });
  };
  handletokenTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tokenType: fieldValue });
  };
  handleGenerateOtp = () => {
    const {
      otpUserId,
      otpRoleId,
      otpDescription,
      otpPageRoute,
      usedAt,
      tokenType,
      sId,
      uId,
    } = this.state;
    if (!otpUserId || !otpRoleId) {
      toast.error("User Id and Role Id are required");
      return;
    }
    this.setState({ isGenerating: true });
    var formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);
    formData.append("userId", otpUserId);
    formData.append("roleId", otpRoleId);
    formData.append("description", otpDescription);
    formData.append("pageRoute", otpPageRoute);
    formData.append("usedAt", usedAt);
    formData.append("tokenType", tokenType);
    fetch(configData.api_url + "C_Tv_tokens/generateOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ generatedOtp: data.otp });
          this.Tv_tokensfetchHandler();
        } else {
          toast.error(data.message);
          this.setState({ isGenerating: false });
        }
      })
      .catch((error) => {
        console.error("Generate OTP error:", error);
        toast.error("Failed to generate OTP");
        this.setState({ isGenerating: false });
      });
  };

  handleCloseOtpModal = () => {
    this.setState({
      showOtpModal: false,
      generatedOtp: "",
      otpUserId: "",
      otpRoleId: "",
      otpDescription: "",
      otpPageRoute: "",
      isGenerating: false,
    });
  };

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this tv_tokens?`)) {
      return;
    }

    var formData = new FormData();
    formData.append("tv_tokens_Id", row.tv_tokens_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Tv_tokens/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tv_tokensfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":
      case "dob_adult":
      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case "telephone":
      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case "mail":
      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Tv Tokens
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      {/* <Button
                variant="primary" style={{ float: "right", marginBottom: "10px" }}
                className="bi bi-plus "
                onClick={this.handleOffcanvasShow}
              >
              New
              </Button> */}

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Tv_tokens</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Token
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletokenChange}
                                        className="form-control"
                                        name="token"
                                        value={this.state.token}
                                        required="required"
                                        placeholder="Enter token"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.token}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        User Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handleuserIdChange}
                                        className="form-control"
                                        name="userId"
                                        value={this.state.userId}
                                        required="required"
                                        placeholder="Enter userId"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.userId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Role Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handleroleIdChange}
                                        className="form-control"
                                        name="roleId"
                                        value={this.state.roleId}
                                        required="required"
                                        placeholder="Enter roleId"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.roleId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Description
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledescriptionChange}
                                        className="form-control"
                                        name="description"
                                        value={this.state.description}
                                        required="required"
                                        placeholder="Enter description"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.description}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Is Active{" "}
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handleisActiveChange}
                                        className="form-control"
                                        name="isActive"
                                        value={this.state.isActive}
                                        required="required"
                                        placeholder="Enter isActive"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.isActive}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Expires At
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={this.handleexpiresAtChange}
                                        className="form-control"
                                        name="expiresAt"
                                        value={this.state.expiresAt}
                                        required="required"
                                        placeholder="Enter expiresAt"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.expiresAt}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Page Route
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlepageRouteChange}
                                        className="form-control"
                                        name="pageRoute"
                                        value={this.state.pageRoute}
                                        placeholder="Enter pageRoute (e.g. opsdashboard)"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.pageRoute}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Used At
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={this.handleusedAtChange}
                                        className="form-control"
                                        name="usedAt"
                                        value={this.state.usedAt}
                                        placeholder="Enter usedAt"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.usedAt}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Token Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={this.state.tokenType}
                                        onChange={this.handletokenTypeChange}
                                        name="tokenType"
                                      >
                                        <option value="">Select</option>
                                        <option value="otp">Single Use</option>
                                        <option value="persistent">
                                          Reusable
                                        </option>
                                      </Form.Control>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.usedAt}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Tv_tokenssubmitHandler}
                                  disabled={
                                    this.state.isSubmitting ||
                                    !this.isFormValid()
                                  }
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  {this.state.isSubmitting ? (
                                    <>
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-1"
                                      />
                                      Saving...
                                    </>
                                  ) : (
                                    "Save"
                                  )}
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Tv_tokens</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      ),
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Token
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handletokenChange}
                                          className="form-control"
                                          name="token"
                                          value={this.state.token}
                                          required="required"
                                          placeholder="Enter token"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.token}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          User Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleuserIdChange}
                                          className="form-control"
                                          name="userId"
                                          value={this.state.userId}
                                          required="required"
                                          placeholder="Enter userId"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.userId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Role Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleroleIdChange}
                                          className="form-control"
                                          name="roleId"
                                          value={this.state.roleId}
                                          required="required"
                                          placeholder="Enter roleId"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.roleId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Description
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handledescriptionChange
                                          }
                                          className="form-control"
                                          name="description"
                                          value={this.state.description}
                                          required="required"
                                          placeholder="Enter description"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.description}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Is Active{" "}
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleisActiveChange}
                                          className="form-control"
                                          name="isActive"
                                          value={this.state.isActive}
                                          required="required"
                                          placeholder="Enter isActive"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.isActive}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Expires At
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={this.handleexpiresAtChange}
                                          className="form-control"
                                          name="expiresAt"
                                          value={this.state.expiresAt}
                                          required="required"
                                          placeholder="Enter expiresAt"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.expiresAt}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Page Route
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlepageRouteChange}
                                          className="form-control"
                                          name="pageRoute"
                                          value={this.state.pageRoute}
                                          placeholder="Enter pageRoute (e.g. opsdashboard)"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.pageRoute}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Used At
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={this.handleusedAtChange}
                                          className="form-control"
                                          name="usedAt"
                                          value={this.state.usedAt}
                                          placeholder="Enter usedAt"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.usedAt}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Token Type
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="select"
                                          className="form-select"
                                          value={this.state.tokenType}
                                          onChange={this.handletokenTypeChange}
                                          name="tokenType"
                                        >
                                          <option value="">Select</option>
                                          <option value="otp">
                                            Single Use
                                          </option>
                                          <option value="persistent">
                                            Reusable
                                          </option>
                                        </Form.Control>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.usedAt}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Tv_tokensupdateHandler}
                                    disabled={
                                      this.state.isSubmitting ||
                                      !this.isFormValid()
                                    }
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    {this.state.isSubmitting ? (
                                      <>
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                          className="me-1"
                                        />
                                        Updating...
                                      </>
                                    ) : (
                                      "Update"
                                    )}
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Button
                        variant="success"
                        style={{
                          float: "right",
                          marginBottom: "10px",
                          marginRight: "10px",
                        }}
                        onClick={() =>
                          this.setState({
                            showOtpModal: true,
                            generatedOtp: "",
                            isGenerating: false,
                          })
                        }
                      >
                        <i className="bi bi-key me-1"></i>Generate OTP
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[
                          100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                        ]}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Generate OTP Modal */}
        <Modal
          show={this.state.showOtpModal}
          onHide={this.handleCloseOtpModal}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.generatedOtp ? "OTP Generated" : "Generate TV OTP"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.generatedOtp ? (
              <div className="text-center py-3">
                <p className="text-muted mb-2">
                  Share this OTP with the TV operator
                </p>
                <div
                  style={{
                    fontSize: "4rem",
                    fontWeight: "700",
                    letterSpacing: "12px",
                    color: "#0f3460",
                    padding: "20px",
                    background: "#f8f9fa",
                    borderRadius: "12px",
                    border: "2px dashed #0f3460",
                  }}
                >
                  {this.state.generatedOtp}
                </div>
                <p className="text-muted mt-3 mb-0">
                  <i className="bi bi-clock me-1"></i>
                  Valid for 30 minutes | Single use only
                </p>
              </div>
            ) : (
              <Form>
                <Row className="mb-3">
                  <Col lg="4">
                    <Form.Label style={{ paddingTop: "8px" }}>
                      User Id <span className="text-danger">*</span>
                    </Form.Label>
                  </Col>
                  <Col lg="8">
                    <Form.Control
                      type="number"
                      value={this.state.otpUserId}
                      onChange={(e) =>
                        this.setState({ otpUserId: e.target.value })
                      }
                      placeholder="Enter userId"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg="4">
                    <Form.Label style={{ paddingTop: "8px" }}>
                      Role Id <span className="text-danger">*</span>
                    </Form.Label>
                  </Col>
                  <Col lg="8">
                    <Form.Control
                      type="number"
                      value={this.state.otpRoleId}
                      onChange={(e) =>
                        this.setState({ otpRoleId: e.target.value })
                      }
                      placeholder="Enter roleId"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg="4">
                    <Form.Label style={{ paddingTop: "8px" }}>
                      Description
                    </Form.Label>
                  </Col>
                  <Col lg="8">
                    <Form.Control
                      type="text"
                      value={this.state.otpDescription}
                      onChange={(e) =>
                        this.setState({ otpDescription: e.target.value })
                      }
                      placeholder="e.g. Lobby TV, Ops Room"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg="4">
                    <Form.Label style={{ paddingTop: "8px" }}>
                      Page Route
                    </Form.Label>
                  </Col>
                  <Col lg="8">
                    <Form.Control
                      type="text"
                      value={this.state.otpPageRoute}
                      onChange={(e) =>
                        this.setState({ otpPageRoute: e.target.value })
                      }
                      placeholder="e.g. opsdashboard"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg="4" md="4">
                    <Form.Label style={{ paddingTop: "8px" }}>
                      Used At
                    </Form.Label>
                  </Col>
                  <Col lg="8" md="8">
                    <Form.Control
                      type="date"
                      onChange={this.handleusedAtChange}
                      className="form-control"
                      name="usedAt"
                      value={this.state.usedAt}
                      placeholder="Enter usedAt"
                    />
                  </Col>
                  <div className="errorMsg" style={{ color: "red" }}>
                    {" "}
                    {this.state.errors.usedAt}{" "}
                  </div>
                </Row>
                <Row className="mb-3">
                  <Col lg="4" md="4">
                    <Form.Label style={{ paddingTop: "8px" }}>
                     Token Type
                    </Form.Label>
                  </Col>
                  <Col lg="8" md="8">
                    <Form.Control
                      as="select"
                      className="form-select"
                      value={this.state.tokenType}
                      onChange={this.handletokenTypeChange}
                      name="tokenType"
                    >
                      <option value="">Select</option>
                      <option value="otp">
                        Single Use
                      </option>
                      <option value="persistent">
                        Reusable
                      </option>
                    </Form.Control>
                  </Col>
                  <div className="errorMsg" style={{ color: "red" }}>
                    {" "}
                    {this.state.errors.tokenType}{" "}
                  </div>
                </Row>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.generatedOtp ? (
              <Button variant="primary" onClick={this.handleCloseOtpModal}>
                Done
              </Button>
            ) : (
              <>
                <Button variant="secondary" onClick={this.handleCloseOtpModal}>
                  Cancel
                </Button>
                <Button
                  variant="success"
                  onClick={this.handleGenerateOtp}
                  disabled={this.state.isGenerating}
                >
                  {this.state.isGenerating ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        className="me-1"
                      />
                      Generating...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-key me-1"></i>Generate
                    </>
                  )}
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
